import { z } from 'zod'
import { baseEntitySchema } from '../../core/entity.js'

const reviewStatuses = ['not-started', 'in-progress', 'completed'] as const
export type ReviewStatus = (typeof reviewStatuses)[number]

const reviewTrackSchema = z.object({
  title: z.string().describe('Track title'),
  trackNumber: z.number().describe('Track number (1-based)'),
  duration: z.number().describe('Duration in seconds').optional(),
  ratings: z.record(z.string(), z.number()).describe('Per-reviewer ratings (userId -> 1-5)'),
  picks: z.record(z.string(), z.boolean()).describe('Per-reviewer top picks (userId -> true)').optional(),
})

export type ReviewTrack = z.infer<typeof reviewTrackSchema>

export const musicReviewSchema = baseEntitySchema.extend({
  type: z.literal('musicreview'),
  title: z.string().describe('Album or release title').optional(),
  artist: z.string().describe('Artist name').optional(),
  artUrl: z.string().describe('Album art URL').optional(),
  externalUrl: z.string().describe('External link (Spotify, Bandcamp, etc.)').optional(),
  tracks: z.array(reviewTrackSchema).describe('Tracks to review').optional(),
  reviewerStatus: z
    .record(z.string(), z.enum(reviewStatuses))
    .describe('Per-reviewer status (userId -> status)')
    .optional(),
  overallRatings: z
    .record(z.string(), z.number())
    .describe('Per-reviewer overall album ratings (userId -> 1-5)')
    .optional(),
})

export type MusicReview = z.infer<typeof musicReviewSchema>

export function isMusicReview(node?: unknown): node is MusicReview {
  return musicReviewSchema.safeParse(node).success
}
